import { Input } from "reactstrap";
import { Href } from "../../../Constants/Constants";
import { ContactFormData, ContactInformationData, OtherContactData } from "../../../Data/Messenger/Messenger";
import { Fragment } from "react/jsx-runtime";

const ContactInformation = () => {
  return (
    <Fragment>
      <div className="status other">
        <h5 className="block-title p-b-25">Contact info</h5>
        <ul> 
          {ContactInformationData.map((item, index) => (
            <li key={index}>
              <h5>
                <a href={item.url}>{item.icon}{item.text}</a>
              </h5>
            </li>
          ))}
        </ul>
      </div>
      <div className="status">
        <ul>
          {ContactFormData.map((item, index) => (
            <li key={index}  className="d-flex gap-2 p-0">
              <div className="media-right form-switch">
                <Input type="checkbox" defaultChecked={item.check} />
              </div>
              <h5>{item.title}</h5>
            </li>
          ))}
        </ul>
      </div>
      <div className="status other">
        <ul>
          {OtherContactData.map((item, index) => (
            <li key={index}>
              <h5>
                <a href={Href}>{item.icon}{item.title}</a>
              </h5>
            </li>
          ))}
        </ul>
      </div>
    </Fragment>
  );
};

export default ContactInformation;
